import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import StatusInfoCard from "./StatusInfoCard";

const OpModeCard = ({ opModeName }) => {
    const { t } = useTranslation();
    if (!opModeName) return null;

    return (
    <StatusInfoCard title={t('message.common.subtitle.opmode')} cardType="charts_text">
        <Box
            sx={{
                borderRadius: 2,
                p: 1.5,
                boxSizing: "border-box",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
                className="no_circle"
            >
                {opModeName}
            </Box>
        </Box>
    </StatusInfoCard>
    );
}

export default OpModeCard;